import { FunctionComponent, CSSProperties } from "react";
import styles from "./NotificationStatusIcon.module.css";
import {
  LabelPairedCircleInfoSmBoldIcon,
  LabelPairedCircleCheckSmBoldIcon,
  LabelPairedCircleExclamationSmBoldIcon,
  LabelPairedTriangleExclamationSmBoldIcon,
} from "@deriv/quill-icons";

import { BadgeNotification } from "@components";

export type NotificationStatusIconProps = {
  className?: string;
  showBadge?: boolean;
  style?: CSSProperties;

  /** Variant props */
  type?: "informative" | "success" | "warning" | "danger";
};

export const NotificationStatusIcon: FunctionComponent<
  NotificationStatusIconProps
> = ({ className = "", type = "informative", showBadge = true, style }) => {
  const statusId = `notification-status-icon-${type}`;

  const iconType = {
    informative: <LabelPairedCircleInfoSmBoldIcon />,
    success: <LabelPairedCircleCheckSmBoldIcon />,
    warning: <LabelPairedTriangleExclamationSmBoldIcon />,
    danger: <LabelPairedCircleExclamationSmBoldIcon />,
  };

  return (
    <div
      className={[styles.root, className].join(" ")}
      data-id={statusId}
      data-type={type}
      style={style}
    >
      <div className={`${styles.containerIcon} notification-icon`}>
        {iconType[type]}
      </div>
      {showBadge && (
        <div className={styles.badgeContainer}>
          <BadgeNotification size="sm" showLabel={false} />
        </div>
      )}
    </div>
  );
};

export default NotificationStatusIcon;
